import React, { useEffect, useState } from 'react';
import { FaFileAlt } from 'react-icons/fa';
import '../../styles/user/pendingCaseSubmission.css';
import {
  fetchUserCandidates,
  startCandidateBGC,
  fetchCandidateInfo,
} from '../../services/user/api';
import { RotateCcw, Trash2 , Search } from 'lucide-react';

const PendingCaseSubmissionPage = ({ onViewReportTwo }) => {
  const [candidates, setCandidates] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [submittingBgc, setSubmittingBgc] = useState(null);
  const [selectedCandidateData, setSelectedCandidateData] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
const [resultModalMessage, setResultModalMessage] = useState('');
const [showResultModal, setShowResultModal] = useState(false);

useEffect(() => {
  loadCandidates(currentPage - 1);
}, [currentPage, entriesPerPage]);


 const loadCandidates = async (page) => {
  try {
    setLoading(true);
    const response = await fetchUserCandidates(page, entriesPerPage);
    if (response?.data?.status) {
      const data = response.data.data;
      const visibleCandidates = (data.content || []).filter(candidate => !candidate.isStartBgc);
      setCandidates(visibleCandidates);
      setTotalElements(data.totalElements || 0); // You may want to update this too if filtering affects pagination
    } else {
      setFetchError(response.data.message || 'Failed to fetch candidates.');
    }
  } catch (error) {
    console.error('API Error:', error);
    setFetchError('An error occurred while fetching data.');
  } finally {
    setLoading(false);
  }
};



const handleRequestForBgc = async (candidateId) => {
  try {
    setSelectedCandidateId(candidateId);
    setShowModal(true);
    setSubmittingBgc(candidateId);

    const response = await startCandidateBGC(candidateId);
    //console.log('BGC API response:', response?.data);

    if (response?.data?.success) {
      // Successfully started BGC
      setCandidates((prev) => prev.filter(c => c.candidateid !== candidateId));
      setTotalElements(prev => prev - 1);
    } 
    // else {
    //   alert(response?.data?.message || 'Failed to start BGC');
    // }
  } catch (error) {
    console.error('Start BGC Error:', error);
    // alert('Error starting BGC process');
  } finally {
    setSubmittingBgc(null);
  }
};


const confirmRequestForBgc = async () => {
  try {
    setSubmittingBgc(selectedCandidateId);
    setShowModal(false);
    
    const response = await startCandidateBGC(selectedCandidateId);
    if (response?.data?.status) {
      setCandidates((prev) => prev.filter(c => c.candidateid !== selectedCandidateId));
      setTotalElements(prev => prev - 1);
      setResultModalMessage('✅ BGC process started successfully');
    } else {
      setResultModalMessage(response?.data?.message || '❌ Failed to start BGC');
    }
  } catch (error) {
    console.error('Start BGC Error:', error);
    setResultModalMessage('❌ Error starting BGC process');
  } finally {
    setSubmittingBgc(null);
    setShowResultModal(true);
  }
};


  const handleViewDetails = async (candidateId) => {
    try {
      const response = await fetchCandidateInfo(candidateId);
      if (response?.data?.status) {
        setSelectedCandidateData(response.data.data);
        setShowReportModal(true);
      } else {
        alert(response?.data?.message || 'Failed to fetch candidate info');
      }
    } catch (error) {
      alert('Error fetching candidate details');
    }
  };

  const startIndex = (currentPage - 1) * entriesPerPage;
  const totalPages = Math.ceil(totalElements / entriesPerPage);

  const filteredCandidates = candidates.filter((c) =>
    c.fullname?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
          <p className="client-header">Pending Case Submission Candidates</p>

    <div className="client-wrapper">

      <div className="clinet-table-controls">
        <div className="entries-select">
          Show{' '}
          <select
  value={entriesPerPage}
  onChange={(e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  }}
>
  <option value="10">10</option>
  <option value="25">25</option>
  <option value="50">50</option>
</select>
{' '}
          entries
        </div>
<div className="client-search-box">
  {/* <label htmlFor="client-search-input">Search:</label> */}
  <div className="client-search-input-wrapper">
    <input
      id="client-search-input"
      type="text"
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
        setCurrentPage(1);
      }}
      placeholder="Search by name"
    />
    <Search className="client-search-icon" size={18} />
  </div>
</div>
      </div>

      <div className="clinet-table-controls">
        {loading ? (
          <div className="loading">Loading...</div>
        ) : fetchError ? (
          <div className="error-message">{fetchError}</div>
        ) : (
          <table className="candidates-table">
            <thead>
              <tr>
                <th>Unique ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile Number</th>
                <th>DOB</th>
                <th>Case Initiated Date</th>
                <th>Case Initiated Time</th>
                <th>View Details</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredCandidates.length > 0 ? (
                filteredCandidates.map((candidate) => (
                  <tr key={candidate.candidateid}>
                    <td className="text-purple-600 font-semibold">{candidate.candidateid}</td>
                    <td className="text-blue-700">{candidate.fullname}</td>
                    <td className="text-gray-700">{candidate.email}</td>
                    <td className="text-green-600">{candidate.mobileNumber}</td>
                    <td className="text-pink-600">{candidate.dateOfBirth}</td>
                    <td>{candidate.caseInitiatedDateOnly}</td>
                    <td>{candidate.caseInitiatedTimeOnly || 'N/A'}</td>
                    <td>
                      <button
                        className="icon-btn text-indigo-600"
                        onClick={() => onViewReportTwo(candidate.candidateid)}
                      >
                        <FaFileAlt />
                      </button>
                    </td>
                    <td>
                      <button
                        className="bgc-request-btn"
                        onClick={() => handleRequestForBgc(candidate.candidateid)}
                        disabled={submittingBgc === candidate.candidateid}
                      >
                        {submittingBgc === candidate.candidateid ? 'Processing...' : 'Request for BGC'}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="no-data">No matching candidates found.</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

{showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p>Are you sure you want to start the BGC process?</p>
            <div className="modal-actions">
              <button className="modal-btn confirm" onClick={confirmRequestForBgc}>Yes</button>
              <button className="modal-btn cancel" onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
{showResultModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      <p>{resultModalMessage}</p>
      <button className="modal-btn confirm" onClick={() => setShowResultModal(false)}>OK</button>
    </div>
  </div>
)}

      {totalPages > 1 && (
  <div className="pagination">
    <div className="pagination-summary">
      <span>
        Showing {startIndex + 1} to{' '}
        {Math.min(startIndex + entriesPerPage, totalElements)} of {totalElements} entries
      </span>
    </div>
    <div className="pagination-buttons">
      {[...Array(totalPages)].map((_, i) => (
        <button
          key={i}
          className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
          onClick={() => setCurrentPage(i + 1)}
        >
          {i + 1}
        </button>
      ))}
    </div>
  </div>
)}

{showReportModal && selectedCandidateData && (
  <div className="modal-overlay">
    <div className="modal-content">
      <button className="close-btn" onClick={() => setShowReportModal(false)}>×</button>
      <h2 className="modal-title">Report</h2>

      {/* Personal Info - Keep as is from previous update */}
      <h3>Personal Info</h3>
      <div className="info-grid">
        {/* ... Personal Info items ... */}
        <div className="info-item">
          <span className="info-label">First Name:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.firstName || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Last Name:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.lastName || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Father's Name:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.fatherName || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">DOB:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.dateOfBirth || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Email:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.email || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Gender:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.gender || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Nationality:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.nationality || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">LinkedIn URL:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.linkedInUrl || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Mobile Number:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.mobileNumber || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Alternate Mobile:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.alternateMobileNumber || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Aadhaar Number:</span>
          <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.aadhaarCardNumber || '-'}</div>
        </div>
        <div className="info-item">
          <span className="info-label">Aadhaar Proof:</span>
          <div className="info-value-box">
            {selectedCandidateData.personalInfoResponse?.aadhaarProofFileName ? (
              <a href={selectedCandidateData.personalInfoResponse.aadhaarProofFileName} target="_blank" rel="noopener noreferrer">View</a>
            ) : ' -'}
          </div>
        </div>
        <div className="info-item">
          <span className="info-label">Personal Image:</span>
          <div className="info-value-box">
            {selectedCandidateData.personalInfoResponse?.personalImageFileName ? (
              <a href={selectedCandidateData.personalInfoResponse.personalImageFileName} target="_blank" rel="noopener noreferrer">View</a>
            ) : ' -'}
          </div>
        </div>
      </div>

      {/* Address Info - Keep as is from previous update */}
      <h3>Address Info</h3>
      <div className="info-grid">
        {/* ... Address Info items ... */}
        <div className="info-item">
          <span className="info-label">Current Address:</span>
          <div className="info-value-box">
            {[
              selectedCandidateData.addressInfoResponse?.currentAddressLine1,
              selectedCandidateData.addressInfoResponse?.currentAddressLine2,
              selectedCandidateData.addressInfoResponse?.currentCity,
              selectedCandidateData.addressInfoResponse?.currentState,
              selectedCandidateData.addressInfoResponse?.currentCountry,
              selectedCandidateData.addressInfoResponse?.currentPinCode
            ].filter(Boolean).join(', ')}
          </div>
        </div>
        <div className="info-item">
          <span className="info-label">Current Address Proof:</span>
          <div className="info-value-box">
            {selectedCandidateData.addressInfoResponse?.currentAddressFile ? (
              <a href={selectedCandidateData.addressInfoResponse.currentAddressFile} target="_blank" rel="noopener noreferrer">View</a>
            ) : ' -'}
          </div>
        </div>
        <div className="info-item">
          <span className="info-label">Permanent Address:</span>
          <div className="info-value-box">
            {[
              selectedCandidateData.addressInfoResponse?.permanentAddressLine1,
              selectedCandidateData.addressInfoResponse?.permanentAddressLine2,
              selectedCandidateData.addressInfoResponse?.permanentCity,
              selectedCandidateData.addressInfoResponse?.permanentState,
              selectedCandidateData.addressInfoResponse?.permanentCountry,
              selectedCandidateData.addressInfoResponse?.permanentPinCode
            ].filter(Boolean).join(', ')}
          </div>
        </div>
        <div className="info-item">
          <span className="info-label">Permanent Address Proof:</span>
          <div className="info-value-box">
            {selectedCandidateData.addressInfoResponse?.permanentAddressFile ? (
              <a href={selectedCandidateData.addressInfoResponse.permanentAddressFile} target="_blank" rel="noopener noreferrer">View</a>
            ) : ' -'}
          </div>
        </div>
      </div>

      {/* Education Info - UPDATED */}
      <h3>Education</h3>
      <ul>
        {selectedCandidateData.educationInfos?.length > 0 ? (
          selectedCandidateData.educationInfos.map((edu, idx) => (
            <li key={idx} className="mb-2">
              <div className="info-item">
                <span className="info-label">Education Level:</span>
                <div className="info-value-box">{edu.educationLevel}</div>
              </div>
              <div className="info-item">
                <span className="info-label">Institute Name:</span>
                <div className="info-value-box">{edu.instituteName}</div>
              </div>
              <div className="info-item">
                <span className="info-label">Qualification:</span>
                <div className="info-value-box">{edu.qualification}</div>
              </div>
              {edu.specialization && (
                <div className="info-item">
                  <span className="info-label">Specialization:</span>
                  <div className="info-value-box">{edu.specialization}</div>
                </div>
              )}
              <div className="info-item">
                <span className="info-label">Enrolled Year:</span>
                <div className="info-value-box">{edu.enrolledYear}</div>
              </div>
              <div className="info-item">
                <span className="info-label">Passing Year:</span>
                <div className="info-value-box">{edu.passingYear}</div>
              </div>
              <div className="info-item">
                <span className="info-label">Location:</span>
                <div className="info-value-box">
                  {[edu.address, edu.city, edu.stateRegionProvince, edu.country, edu.zipCode].filter(Boolean).join(', ')}
                </div>
              </div>
              <div className="info-item">
                <span className="info-label">Certificate:</span>
                <div className="info-value-box">
                  {edu.certificateFileUrl ? (
                    <a href={edu.certificateFileUrl} target="_blank" rel="noopener noreferrer">View</a>
                  ) : ' -'}
                </div>
              </div>
            </li>
          ))
        ) : (
          <li>No education info available.</li>
        )}
      </ul>

      {/* Employment Info - UPDATED */}
      <h3>Employment</h3>
      <ul>
        {selectedCandidateData.employmentInfos?.length > 0 ? (
          selectedCandidateData.employmentInfos.map((emp, idx) => (
            <li key={idx} className="mb-2">
              <div className="info-item">
                <span className="info-label">Company:</span>
                <div className="info-value-box">{emp.companyName} ({emp.employeeCode})</div>
              </div>
              <div className="info-item">
                <span className="info-label">Job Title:</span>
                <div className="info-value-box">{emp.jobTitle}</div>
              </div>
              <div className="info-item">
                <span className="info-label">Working From:</span>
                <div className="info-value-box">{emp.workingFrom}</div>
              </div>
              <div className="info-item">
                <span className="info-label">Working To:</span>
                <div className="info-value-box">{emp.workingTo}</div>
              </div>
              <div className="info-item">
                <span className="info-label">Location:</span>
                <div className="info-value-box">{emp.location}</div>
              </div>
              <div className="info-item">
                <span className="info-label">HR Contact Email:</span>
                <div className="info-value-box">{emp.hrContactEmail}</div>
              </div>
              <div className="info-item">
                <span className="info-label">HR Contact Number:</span>
                <div className="info-value-box">{emp.hrContactNumber}</div>
              </div>
              <div className="info-item">
                <span className="info-label">UAN Number:</span>
                <div className="info-value-box">{emp.uanNumber}</div>
              </div>
              <div className="info-item">
                <span className="info-label">Offer Letter:</span>
                <div className="info-value-box">
                  {emp.offerLetterUrl ? (
                    <a href={emp.offerLetterUrl} target="_blank" rel="noopener noreferrer">View</a>
                  ) : ' -'}
                </div>
              </div>
              <div className="info-item">
                <span className="info-label">Experience Letter:</span>
                <div className="info-value-box">
                  {emp.experienceLetterUrl ? (
                    <a href={emp.experienceLetterUrl} target="_blank" rel="noopener noreferrer">View</a>
                  ) : ' -'}
                </div>
              </div>
              <div className="info-item">
                <span className="info-label">Form 16:</span>
                <div className="info-value-box">
                  {emp.form16Url ? (
                    <a href={emp.form16Url} target="_blank" rel="noopener noreferrer">View</a>
                  ) : ' -'}
                </div>
              </div>
              <div className="info-item">
                <span className="info-label">Form 26:</span>
                <div className="info-value-box">
                  {emp.form26Url ? (
                    <a href={emp.form26Url} target="_blank" rel="noopener noreferrer">View</a>
                  ) : ' -'}
                </div>
              </div>
              <div className="info-item">
                <span className="info-label">Bank Statement:</span>
                <div className="info-value-box">
                  {emp.bankStatementUrl ? (
                    <a href={emp.bankStatementUrl} target="_blank" rel="noopener noreferrer">View</a>
                  ) : ' -'}
                </div>
              </div>
              {/* Salary Slips - Special handling as it can have multiple links */}
              <div className="info-item salary-slips-info-item"> {/* Apply info-item here too */}
                <span className="info-label">Salary Slips:</span>
                <div className="info-value-box salary-slips-links">
                  {emp.salarySlipsUrl ? emp.salarySlipsUrl.split(',').map((url, index) => (
                    <div key={index}>
                      <a href={url} target="_blank" rel="noopener noreferrer">View Slip {index + 1}</a>
                    </div>
                  )) : ' -'}
                </div>
              </div>
            </li>
          ))
        ) : (
          <li>No employment info available.</li>
        )}
      </ul>
    </div>
  </div>
)}
    </div>
    </>
  );
};

export default PendingCaseSubmissionPage;
